import type { TOC } from '@ember/component/template-only';

const DataPerformanceInsightsSvgAvgIncreaseComponent: TOC<Record<string, never>> = <template>
	<svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g class="other wave">
			<path
				opacity="0.5"
				d="M2.91406 8.63037C9.05191 8.63037 7.1488 23.8048 12.9338 23.8048C19.6388 23.8048 16.1854 8.63037 21.983 8.63037C28.1208 8.63037 26.0539 23.8048 31.8388 23.8048"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<g class="focused">
			<path
				d="M31.8784 13.2173H2.89062"
				stroke="#25A767"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-dasharray="0.1 3"
			/>
		</g>
	</svg>
</template>;

export default DataPerformanceInsightsSvgAvgIncreaseComponent;
